var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorSwatch64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M64 0v64H0V0h64zM27.71 6.763H12.817a5.053 5.053 0 00-5.053 5.053V41.68c-1.61 5.604.722 11.793 6 14.84 6.218 3.59 14.169 1.46 17.758-4.758l16.974-29.4a5.053 5.053 0 00-1.85-6.901L32.882 7.514a5.035 5.035 0 00-3.708-.537 5.077 5.077 0 00-1.462-.214z",
    id: "color-swatch-64_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0v64H0V0h64zM27.974 7.026H13.079a5.053 5.053 0 00-5.053 5.053v33.447c0 6.904 5.597 12.5 12.5 12.5 6.904 0 12.5-5.596 12.5-12.5V12.08a5.053 5.053 0 00-5.052-5.053z",
    id: "color-swatch-64_svg__c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "color-swatch-64_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#color-swatch-64_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.912 18.33c.85-.49 1.818-.59 2.696-.355a3.542 3.542 0 012.157 1.656h0l7.948 13.765c.49.85.59 1.817.355 2.696a3.542 3.542 0 01-1.656 2.157h0L26.013 55.222a11.464 11.464 0 01-8.726 1.15 11.464 11.464 0 01-6.983-5.359 11.464 11.464 0 01-1.149-8.726 11.464 11.464 0 015.358-6.983h0z",
    stroke: "#000",
    strokeWidth: 3,
    fillOpacity: 0.2,
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#color-swatch-64_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "color-swatch-64_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#color-swatch-64_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.698 8.722a3.542 3.542 0 012.696.355h0l13.765 7.947c.85.49 1.42 1.279 1.655 2.157a3.542 3.542 0 01-.355 2.696h0l-16.973 29.4a11.464 11.464 0 01-6.983 5.357 11.464 11.464 0 01-8.727-1.148 11.464 11.464 0 01-5.358-6.983 11.464 11.464 0 011.149-8.727h0l16.974-29.399a3.542 3.542 0 012.157-1.655z",
    stroke: "#000",
    strokeWidth: 3,
    fillOpacity: 0.1,
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#color-swatch-64_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.21 7.763c.982 0 1.87.398 2.513 1.04a3.542 3.542 0 011.04 2.513h0v33.947c0 3.176-1.287 6.05-3.368 8.132a11.464 11.464 0 01-8.132 3.368c-3.175 0-6.05-1.287-8.132-3.368a11.464 11.464 0 01-3.368-8.132h0V11.316c0-.981.398-1.87 1.04-2.512a3.542 3.542 0 012.513-1.04h0z",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    strokeWidth: 3,
    cx: 20.263,
    cy: 45.263,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatch64);
export default __webpack_public_path__ + "static/media/color-swatch-64.5d595c40.svg";
export { ForwardRef as ReactComponent };